import { timeFormat } from '@/utils'
export default function () {
  return [
    {
      title: '办理序号',
      [$field]: 'index',
      width: 100,
      render: (h, row) => {
        return h('span', row.index + 1)
      }
    },
    {
      title: '步骤',
      [$field]: 'stepName'
    },
    {
      title: '办理人员',
      [$field]: 'userName' 
    },
    {
      title: '办理组织',
      [$field]: 'orgName' 
    },
    {
      title: '办理时间',
      [$field]: 'auditTime',
      'render' (c, {row}) {
        return c('span', timeFormat(row.auditTime, 'yyyy-MM-dd HH:mm:ss'))
      }
    },
    {
      title: '办理结果',
      [$field]: 'showText'
    }
  ]
}
